/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Label type enumeration.
 */
export type LabelKind = typeof LabelKind[keyof typeof LabelKind];


export const LabelKind = {
  premiere: 'premiere',
  fresh: 'fresh',
  abandoned: 'abandoned',
  exclusive: 'exclusive',
  top: 'top',
} as const;
